"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftProposalRejectDto = instanceOfShiftProposalRejectDto;
exports.ShiftProposalRejectDtoFromJSON = ShiftProposalRejectDtoFromJSON;
exports.ShiftProposalRejectDtoFromJSONTyped = ShiftProposalRejectDtoFromJSONTyped;
exports.ShiftProposalRejectDtoToJSON = ShiftProposalRejectDtoToJSON;
exports.ShiftProposalRejectDtoToJSONTyped = ShiftProposalRejectDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftProposalRejectDto interface.
 */
function instanceOfShiftProposalRejectDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    return true;
}
function ShiftProposalRejectDtoFromJSON(json) {
    return ShiftProposalRejectDtoFromJSONTyped(json, false);
}
function ShiftProposalRejectDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileId': json['nurseProfileId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}
function ShiftProposalRejectDtoToJSON(json) {
    return ShiftProposalRejectDtoToJSONTyped(json, false);
}
function ShiftProposalRejectDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileId': value['nurseProfileId'],
        'reason': value['reason'],
    };
}
//# sourceMappingURL=ShiftProposalRejectDto.js.map